import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../utils/api';
// Define the initial state using that type
const initialState = {
  open: false,
  activeTab: 0,
  category: 0,
  totalUnread: 0,
  listStockShow: [],
  notifications: [],
  notificationTotal: 0,
  isNotificationLoading: false,
};

export const getNotifications = createAsyncThunk(
  'notification/getNotifications',
  async (payload) => {
    const response = await api.post('/notification/get-notifications-by-user', {
      ids: payload,
    });
    return { ...response.data, listStockShow: payload };
  }
);

export const notificationSlice = createSlice({
  name: 'notification',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setOpenNotificationDrawer: (state, { payload }) => {
      state.open = true;
      state.activeTab = payload?.tab || 0;
      state.category = payload?.category || 0;
    },
    setCloseNotificationDrawer: (state) => {
      state.open = false;
      state.activeTab = 0;
      state.category = 0;
    },
    updateTotalUnread: (state, { payload }) => {
      state.totalUnread = payload;
    },
    updateNotifications: (state, { payload }) => {
      state.notifications = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNotifications.pending, (state) => {
      state.isNotificationLoading = true;
    });
    builder.addCase(getNotifications.fulfilled, (state, action) => {
      state.isNotificationLoading = false;
      state.notifications = action.payload.results;
      state.notificationTotal = action.payload.total;
      state.listStockShow = action.payload.listStockShow;
    });
  },
});

export const {
  setOpenNotificationDrawer,
  setCloseNotificationDrawer,
  updateTotalUnread,
  updateNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
